// "Likely related · N · not applied unless ticked" tray -- low-confidence
// rows sit here and are SHOWN but never counted into the kept set unless the
// user explicitly ticks one (binding rule: low-confidence rows are shown,
// never applied unless ticked). `#foundation` step 3, `#s07` phone.
import { AskMatchRow } from './AskMatchRow';
import type { AskMatchRow as AskMatchRowType } from '@/api/hooks/useAskPreview';

export function LikelyRelatedTray({
  rows,
  keptIds,
  onToggle,
}: {
  rows: AskMatchRowType[];
  keptIds: Set<string>;
  onToggle: (id: string) => void;
}) {
  if (rows.length === 0) return null;
  return (
    <div className="mt-2.5 rounded-lg border border-border bg-muted/30 p-2.5" data-testid="likely-related-tray">
      <div className="mb-1.5 flex items-center gap-1.5 text-xs text-muted-foreground">
        <span
          aria-hidden="true"
          className="h-2 w-2 rounded-full border-2 border-confidence-low box-border"
        />
        Likely related · {rows.length} · not applied unless ticked
      </div>
      {rows.map((row) => (
        <AskMatchRow key={row.id} row={row} kept={keptIds.has(row.id)} onToggle={onToggle} />
      ))}
    </div>
  );
}

export default LikelyRelatedTray;
